module.exports = __webpack_public_path__ + "img/SES_8299.d495b0bc.jpg";